/**
 * @fileoverview Page 404 brandée du portail citoyen.
 *
 * Rendue par la route catch-all (`path: '*'`) déclarée DANS le layout — le
 * citoyen conserve ainsi le header et le footer du portail au lieu de tomber
 * sur l'écran brut de React Router. Le composant est aussi réutilisé comme
 * `errorElement` de la route racine : en cas d'erreur de rendu inattendue, il
 * s'affiche alors seul (sans layout), raison pour laquelle il porte ses
 * propres marges et sa largeur maximale.
 *
 * Le ton reste rassurant : une URL erronée n'a aucune conséquence sur les
 * contraventions ou les paiements du citoyen, et les deux actions proposées
 * ramènent vers un parcours connu (accueil ou recherche).
 */

import { Link } from 'react-router-dom';
import { Button, PortalState } from '@gnpc/ui';

/**
 * Écran « Page introuvable » du portail citoyen.
 *
 * @returns Panneau `PortalState` (statut `empty`) avec retour à l'accueil et
 *   accès direct à la recherche de contravention.
 */
export function NotFoundPage(): JSX.Element {
  return (
    <div className="mx-auto w-full max-w-3xl px-4 py-10">
      <PortalState
        status="empty"
        // La 404 EST le contenu principal : son titre porte le `<h1>` de la
        // page (axe `page-has-heading-one`).
        titleAs="h1"
        title="Page introuvable"
        action={
          <Button asChild>
            <Link to="/">Retour à l'accueil</Link>
          </Button>
        }
        secondaryAction={
          <Button asChild variant="outline">
            <Link to="/recherche">Rechercher une contravention</Link>
          </Button>
        }
      >
        L'adresse demandée n'existe pas ou n'est plus disponible. Rien n'est perdu : vos
        contraventions et vos paiements ne sont pas affectés. Vérifiez le lien saisi ou repartez
        d'une page connue.
      </PortalState>
    </div>
  );
}
